<template>
  <div>
    <div class="company">
      <div class="company_left">
        <div class="cover-box">
          <img :src="queryParams.imgLink" v-if="queryParams.imgLink" class="solve-cover" />
        </div>

        <el-form
          :model="queryParams"
          ref="rulesCompanyInfo"
          class="companyInfo"
        >
          <div class="info">
            <div>
              <div class="fullName">
                <div class="companyFullName">
                  {{ queryParams.title || "--" }}
                </div>
              </div>
            </div>

            <div class="updateTime">
              {{ queryParams.id }}
            </div>
          </div>
        </el-form>
      </div>

      <div class="company_center">
        <div class="company_data">
          <div class="label">
            数据质量
          </div>

          <!-- 数据质量字段缺失 -->
          <div class="value_num">
            {{ queryParams.dataQuality || "-" }}
          </div>
        </div>

        <div class="company_circle">
          <div class="label">
            数据完整度
          </div>

          <div class="circle_content">
            <el-progress
              type="circle"
              :percentage="
                queryParams.dataCompletion
                  ? Number(queryParams.dataCompletion)
                  : 0
              "
              :stroke-width="10"
              :width="100"
            ></el-progress>
          </div>
        </div>
      </div>

      <div class="company_right">
        <el-button
          type="primary"
          class="back-btn"
          plain
          @click="cancelItem"
          icon="ali-icon-back"
        >
          返回上级
        </el-button>

        <div class="company_edit_info">
          <div class="company_edit_item">
            <img src="@/assets/img/user-line.png" alt="" />

            <p>修改人：{{ queryParams.updateName || "--" }}</p>
          </div>

          <div class="company_edit_item">
            <img src="@/assets/img/update-icon.png" alt="" />

            <p>更新：{{ queryParams.updateTime || "--" }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="new_info">
      <el-tabs v-model="activeName" @tab-click="handleClick" @before-leave="tabsBeforeLeave">
        <el-tab-pane label="基本信息" name="first">
          <BasicInformation ref="basicInformation" :queryParams="queryParams" />
        </el-tab-pane>

        <el-tab-pane label="实体关联" name="second">
          <RelatesInfo ref="relatesInfo" />
        </el-tab-pane>

        <el-tab-pane label="手动标签" name="third">
          <LabelManagement ref="labelManagement" :newsData="Number(newsData)" />
        </el-tab-pane>

        <el-tab-pane label="数据日志" name="dataEementInfo">
          <DataElementInfo ref="dataElementInfo" />
        </el-tab-pane>

        <!-- <el-tab-pane label="半自动标签" name="four">
        <Robotizationlabel ref="robotizationlabel" :newsId="Number(newsData)" />
      </el-tab-pane> -->
      </el-tabs>

      <div
        style="height: 50px; background: #fff; border-top: 1px solid #dbdbdb;"
        v-if="this.activeName == 'four'"
      ></div>

      <div class="bottom" v-if="activeName !== 'four'">
        <el-button
          type="primary"
          @click="saveItem(activeName)"
          v-if="personType"
          >修改
        </el-button>
        <el-button @click="cancelItem">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import BasicInformation from "./components/BasicInformation";
import LabelInfo from "./components/LabelInfo";
import LabelManagement from "./components/LabelManagement";
import Robotizationlabel from "./components/Robotizationlabel";
// 编辑资讯基本信息 / 标签信息编辑 / 标签信息查询 / 手动标签保存
import CompanyInfoBar from "@/components/CompanyInfoBar/index.vue";
import DataElementInfo from "./components/DataElementInfo";
import RelatesInfo from "./components/RelatesInfo.vue";

import {
  editNew,
  editNewsKeywordLabel,
  getNewsKeywordLabel,
  insertHandLabel,
  insertHandLabelUpdate,
  editNewsInfo
} from "@/api/news.js";
export default {
  name: "newsInfo",
  components: {
    BasicInformation,
    LabelInfo,
    LabelManagement,
    Robotizationlabel,
    CompanyInfoBar,
    DataElementInfo,
    RelatesInfo
  },
  data() {
    return {
      newsId: "", // 数据唯一id（新增保存的id）
      activeName: "first", //tab栏绑定的名称
      queryParams: {
        title: "", // 资讯标题
        infoCategory: "", // 资讯类别
        informationType: "", // 资讯类型
        titleLink: "", // 资讯链接
        origin: "", // 资讯来源
        author: "", // 资讯作者
        introduction: "", // 资讯描述
        newsFileList: [], // 附件
        imgLinkList: [], // 资讯图片
        coverImageList: [], // 封面图片
        shareImage: [], // 分享图片
        informationBrief: "", // 一句话介绍
        articleReleaseDate: "", // 发布时间
        newsLabelList: [], // 赋能行业标签组
        crawlerNumber: "", // 爬虫编号
        crawlerName: "", // 爬虫名称
        crawlWebsite: "", // 爬取网站
        crawlTime: "" // 爬取时间
      }
    };
  },
  computed: {
    // 0 新增 1 编辑 点击新增/编辑页面按钮调整路径带过来的
    personType() {
      return Number(this.$route.query.personType);
    },
    newsData() {
      return this.$route.query.newsData;
    },
    newsEdit() {
      return this.$route.query.newsEdit;
    },
    coverImage() {
      if (
        Array.isArray(this.queryParams.coverImageList) &&
        this.queryParams.coverImageList.length > 0
      ) {
        return this.queryParams.coverImageList[0];
      } else {
        return "";
      }
    }
  },
  watch: {
    // 监听是否在手动标签页面
    activeName: {
      handler(newVal, oldVal) {
        // if (newVal !== oldVal && newVal == "third") {
        //   this.$refs.labelManagement.getBylabelId();
        // }
        this.getFormData(newVal);
        this.saveItem(oldVal);
      }
    }
  },
  created() {
    // this.getNewsKeywordLabel(); //标签信息查询
  },
  mounted() {
    this.$nextTick(() => {
      this.getFormData(this.activeName);
    });
  },
  methods: {
    getFormData(activeName) {
      switch (activeName) {
        case "first":
          this.$refs.basicInformation.getInfo();
          break;
        case "second":
          this.$refs.relatesInfo.getInfo();
          break;
      }
    },
    tabsBeforeLeave(e) {
      console.log(e);
      return false;
    },
    // 切换tabs页(切换到手动标签,调用查询回显的数据)
    handleClick(tab, event) {
      if (tab.index == 2 && this.saveCaseDataId) {
        this.$refs.labelManagement.getBylabelId();
      }
    },
    saveLabel() {
      if (!this.newsData) {
        this.$message.error("请先保存基本信息的数据再进行下一步操作！");
      } else {
        let query = [];

        this.$refs.labelManagement.radiolist.forEach(el => {
          if (this.queryParams.title) {
            el.labelparam.title = this.queryParams.title;
          }

          if (el.labelparam.labelNameList.length > 0) {
            el.labelparam.reportId = this.saveCaseDataId;
            query.push(el.labelparam);
          }
        });

        if (query.length > 0) {
          this.$modal.loading("正在保存数据，请稍候...");
          if (this.personType == 0) {
            insertHandLabelUpdate(query)
              .then(response => {
                if (response.code == 200) {
                  this.$message.success("保存成功");
                  // this.activeName = "four";
                } else {
                  this.$message.error(response.data.message);
                }
              })
              .finally(() => {
                this.$modal.closeLoading();
              });
          } else {
            insertHandLabelUpdate(query)
              .then(response => {
                if (response.code == 200) {
                  this.$message.success("编辑成功");
                  // this.activeName = "four";
                } else {
                  this.$message.error(response.data.message);
                }
              })
              .finally(() => {
                this.$modal.closeLoading();
              });
          }
        } else {
          this.$message.warning("请勾选标签！");
        }
      }
    },
    // 保存接口
    saveItem(activeName) {
      switch (activeName) {
        case "first":
          this.$refs.basicInformation?.submit();
          break;
        case "third":
          this.saveLabel();
          break;
      }

      return;

      let res;
      switch (this.activeName) {
        case "first":
          this.$refs.basicInformation.$refs.basicInformationRule.validate(
            async valid => {
              if (valid) {
                // this.$refs.basicInformation.newsData.informationType =
                //   this.$refs.basicInformation.newsData.informationTypes.join(
                //     ","
                //   );
                const res = await editNewsInfo(
                  this.$refs.basicInformation.newsData
                );

                if (res.code === 200) {
                  // if (res.data !== "修改成功" && res.data !== "") {
                  //   this.newsData = res.data;
                  // }
                  this.$message.success("修改成功");

                  this.activeName = "second";
                } else {
                  this.$message.error(res.msg);
                }
              }
            }
          );
          break;
        case "second":
          this.$refs.labelInfo.$refs.labelInfoForm.validate(async valid => {
            if (valid) {
              //最终组装的数组
              let arr = [];
              //开始添加
              this.$refs.labelInfo.newsKeywordLabelResultParam.reportKeywordAddParamList.forEach(
                item => {
                  let keyword = item.keyword;
                  let keywordDescribe = item.keywordDescribe;
                  let reportLabelList = [];
                  // 遍历我添加的数组
                  item.reportLabelList.forEach(child => {
                    // 遍历总数组
                    this.$refs.labelInfo.labelOptions.forEach(item1 => {
                      if (item1.labelKeywordResultList[0].id == child.labelId) {
                        item1.labelKeywordResultList.forEach(name => {
                          name = {
                            groupLabelId: name.groupLabelPrefix,
                            groupLabelName: name.groupLabelType,
                            labelId: name.id,
                            labelName: name.labelName,
                            labelStatus:
                              item1.labelKeywordResultList[0].id == name.id
                                ? 1
                                : 0
                          };
                          reportLabelList.push(name);
                        });
                      }
                    });
                  });

                  let all = {
                    keyword: keyword,
                    keywordDescribe: keywordDescribe,
                    reportLabelList: reportLabelList
                  };
                  arr.push(all);
                }
              );

              // 最终提交后端的数据
              let newsKeywordLabelResultParam = {
                keywordVersion: this.$refs.labelInfo.newsKeywordLabelResultParam
                  .keywordVersion, //关键字版本
                reportId: this.newsData,
                reportKeywordAddParamList: arr
              };
              // 判断是编辑还是新增 1编辑  0新增
              if (!this.personType) {
                // 如果未保存基本信息
                if (!this.newsData) {
                  this.$message.error(
                    "请先保存基本信息的数据再进行下一步操作！"
                  );
                } else {
                  this.$refs.labelInfo.$refs.labelInfoForm.validate(
                    async valid => {
                      if (valid) {
                        res = await editNewsKeywordLabel(
                          newsKeywordLabelResultParam
                        );
                        if (res.code == 200) {
                          this.$message.success("新增成功!");
                          this.activeName = "third";
                        } else {
                          this.$message.error("新增失败，请稍候重试!");
                        }
                      }
                    }
                  );
                }
              } else {
                this.$refs.labelInfo.$refs.labelInfoForm.validate(
                  async valid => {
                    if (valid) {
                      res = await editNewsKeywordLabel(
                        newsKeywordLabelResultParam
                      );
                      if (res.code == 200) {
                        this.$message.success("编辑成功!");
                        this.activeName = "third";
                      } else {
                        this.$message.error("编辑失败，请稍候重试!");
                      }
                    }
                  }
                );
              }
            }
          });
          break;
        case "third":
          if (!this.newsData) {
            this.$message.error("请先保存基本信息的数据再进行下一步操作！");
          } else {
            let query = [];

            this.$refs.labelManagement.radiolist.forEach(el => {
              if (this.$route.query.title) {
                el.labelparam.title = this.$route.query.title;
              }

              if (el.labelparam.labelNameList.length > 0) {
                el.labelparam.reportId = this.saveCaseDataId;
                query.push(el.labelparam);
              }
            });

            if (query.length > 0) {
              this.$modal.loading("正在保存数据，请稍候...");
              if (this.personType == 0) {
                insertHandLabelUpdate(query)
                  .then(response => {
                    if (response.code == 200) {
                      this.$message.success("保存成功");
                      // this.activeName = "four";
                    } else {
                      this.$message.error(response.data.message);
                    }
                  })
                  .finally(() => {
                    this.$modal.closeLoading();
                  });
              } else {
                insertHandLabelUpdate(query)
                  .then(response => {
                    if (response.code == 200) {
                      this.$message.success("编辑成功");
                      // this.activeName = "four";
                    } else {
                      this.$message.error(response.data.message);
                    }
                  })
                  .finally(() => {
                    this.$modal.closeLoading();
                  });
              }
            } else {
              this.$message.warning("请勾选标签！");
            }
          }
          break;
        case "four":
          break;
        default:
          break;
      }
    },
    // 案例标签信息详情
    async getNewsKeywordLabel() {
      const res = await getNewsKeywordLabel({
        id: this.newsData
      });
      if (res.code == 200) {
        // 如果请求的标签数据为null的情况，就处理下
        if (!res.data.reportKeywordAddParamList) {
          this.$refs.labelInfo.newsKeywordLabelResultParam = {
            reportId: "", // 案例主键
            keywordVersion: "", // 关键字版本
            // type: null,
            reportKeywordAddParamList: [
              {
                reportLabelList: [
                  {
                    groupLabelId: "", // 标签组编号
                    groupLabelName: "", // 标签组名称
                    labelId: "", // 标签编号
                    labelName: "", // 标签内容
                    reportKeywordId: null,
                    id: null,
                    superiorLabel: null // 上级标签
                  }
                ],
                keyword: "", // 关键词
                keywordDescribe: "" // 关键词数据
              }
            ]
          };
        } else {
          this.$refs.labelInfo.newsKeywordLabelResultParam = res.data;
          // 请求数据回来后，将标签内容也改为（标签组名称+标签内容）
          res.data.reportKeywordAddParamList.forEach(item => {
            item.reportLabelList.forEach(child => {
              child.labelName = child.groupLabelName + "/" + child.labelName;
            });
          });
        }
      }
    },
    // 取消按钮
    cancelItem() {
      this.$router.go(-1);
      this.$router.push({
        path: "/newsInformation"
      });
    }
  }
  // mounted() {
  //   document.getElementsByClassName("new_info")[0].style.height =
  //     document.body.clientHeight - 120 + "px";
  // },
};
</script>

<style lang="less" scoped>
.new_info {
  box-sizing: border-box;
  padding: 0 20px;
  background-color: #ffffff;
  overflow: auto;
  border-radius: 4px;
}
#pane-first {
  height: 100% !important;
  overflow: scroll !important;
}
/deep/.el-tabs--top {
  height: 93%;
  overflow: scroll !important;
}
/deep/.el-tabs__content {
  overflow: scroll !important;
  height: 630px !important;
  min-height: 630px !important;
}

.company {
  background: #fff;
  padding: 20px 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;

  .company_left {
    display: flex;
    align-items: center;

    .cover-box {
      width: 80px;
      height: 80px;
      border-radius: 4px;
      background-color: #e6e6e6;
      overflow: hidden;
    }

    .upload-box {
      position: relative;
      border-radius: 4px;
      overflow: hidden;

      .upload-label {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 21px;
        line-height: 21px;
        font-size: 10px;
        color: #ffffff;
        background-color: #15151540;
        text-align: center;
      }
    }

    .solve-cover {
      display: block;
      width: 80px;
      height: 80px;
    }

    .info {
      margin: 8px 0 8px 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;

      .fullName {
        margin-bottom: 10px;
        display: flex;
        align-items: center;

        &.hide {
          width: 0;
          height: 0;
          overflow: hidden;
        }

        .jr-iconjr-icon-edit1:hover {
          color: #4d77ff;
        }
        .el-button {
          margin-left: 10px;
        }
        .companyFullName {
          font-size: 24px;
          color: #363e4d;
        }
        i {
          margin-left: 10px;
        }
      }

      .updateTime {
        color: #333333;
        font-size: 16px;
        margin-top: 5px;
      }
    }
  }

  .edit-group {
    display: flex;
    align-items: center;
  }

  .company_center {
    display: flex;

    .label {
      font-size: 16px;
      color: #333333;
    }

    .company_data {
      margin-right: 45px;

      .value_num {
        margin-top: 8px;
        height: 43px;
        line-height: 43px;
        font-size: 22px;
        font-weight: 500;
        text-align: center;
      }
    }

    .company_circle {
      .circle_content {
        margin-top: 8px;
      }
      // .circle_content {
      //   margin-top: 8px;
      //   width: 50px;
      //   height: 50px;
      // }
    }

    .company_circle,
    .company_data {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .company_right {
    display: flex;

    .back-icon {
      width: 18px;
      height: 18px;
    }

    .context {
      line-height: 18px;
    }

    .company_button {
      display: flex;
      align-items: center;
      font-size: 14px;
    }

    .company_edit_info {
      margin-left: 20px;
      font-size: 14px;
      color: #999999;

      .company_edit_item {
        margin-bottom: 8px;
        display: flex;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }

        p {
          height: 20px;
          line-height: 20x;
        }

        img {
          margin-right: 5px;
          width: 14px;
          height: 14px;
        }
      }
    }
  }

  .back-btn {
    display: flex;
    align-items: center;
  }
}
</style>
